function dropdown() {
    const head = document.querySelector('.gh-navigation');
    const menu = head.querySelector('.gh-navigation-menu');
    const nav = menu?.querySelector('.nav');
    if (!nav) return;

    const logo = document.querySelector('.gh-navigation-logo');
    const navHTML = nav.innerHTML;

    const items = nav.querySelectorAll('li');
    let itemIndex = {};
    let currentParentItem;

    items.forEach(function (item, index) {
      const classString = Array.from(item.classList).join(' ');

      if (classString.includes('has_child')) {
        currentParentItem = index;
        itemIndex[index] = {elements: [], item: item};
      }
      else if (classString.includes('subitem') && currentParentItem !== null && itemIndex[currentParentItem]) {
        itemIndex[currentParentItem].elements.push(item);
        item.remove();
      }
      item.style.transitionDelay = `${0.03 * (index + 1)}s`;
    });


    const makeDropdown = function () {
      let submenuItems = [];

      if (!Object.keys(itemIndex).length) {
        head.classList.add('is-dropdown-loaded');
        return;
      }

      for (let itemKey in itemIndex) {
        let item = itemIndex[itemKey].item;
        let contentDiv = item.children[0];
        let aDiv = contentDiv.children[0];
        aDiv.innerHTML = aDiv.innerHTML.replace('[has_child]', '');
        aDiv.href = 'javascript:void(0)';
        aDiv.classList.add('gh-has-dropdown');
        contentDiv.insertAdjacentHTML('beforeend', "<svg width='10' height='10' viewBox='0 0 19 10' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M1.74805 1.52002L9.54883 9.00002L17.3496 1.52002' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></svg>");

        const wrapper = document.createElement('ul');
        wrapper.setAttribute('class', 'gh-dropdown');

        if (itemIndex[itemKey].elements.length >= 10) {
            head.classList.add('is-dropdown-mega');
            wrapper.style.gridTemplateRows = `repeat(${Math.ceil(submenuItems.length / 2)}, 1fr)`;
        } else {
            head.classList.remove('is-dropdown-mega');
        }

        itemIndex[itemKey].elements.forEach(function (child) {
          child.innerHTML = child.innerHTML.replace('[subitem]', '');
          wrapper.appendChild(child);
        });

        item.appendChild(wrapper);
        const toggleRect = item.getBoundingClientRect();
        const documentCenter = window.innerWidth / 2;

        if (toggleRect.left < documentCenter) {
            wrapper.classList.add('is-left');
        }

        window.addEventListener('click', function (e) {
          if (item.classList.contains('is-dropdown-open')) {
            item.classList.remove('is-dropdown-open');
          }
          else if (item.contains(e.target)) {
            item.classList.add('is-dropdown-open');
          }
        });
      }

      head.classList.add('is-dropdown-loaded');
    }

    imagesLoaded(logo, function () {
        makeDropdown();
    });

    window.addEventListener('load', function () {
        if (!logo) {
            makeDropdown();
        }
    });
}
